import { Component, OnInit } from '@angular/core';
import { SalesReportService } from '../sales-report.service';

@Component({
  selector: 'app-sales-report-first-tab',
  templateUrl: './sales-report-first-tab.component.html',
  styleUrls: ['./sales-report-first-tab.component.css']
})
export class SalesReportFirstTabComponent implements OnInit {

  constructor(
    public salesReportService: SalesReportService
  ) { }

  ngOnInit(): void {
  }

}
